<div class="tp-page tp-page--compact certifications-container">
  <section class="tp-card tp-card--flush">
    <tp-page-header variant="toolbar" title="Certificaciones"
    [subtitle]="certifications.length + (certifications.length === 1 ? ' certificación' : ' certificaciones')">
    <button mat-flat-button actions id="addButton" type="button" (click)="dialogAction()">
      <mat-icon>add</mat-icon>
      Agregar certificación
    </button>
    </tp-page-header>
    <ul class="sa-list">
      @for (cert of certifications; track cert) {
        <li class="sa-item">
          <img
            class="sa-item__icon"
            src="../assets/icons/certifications/Certification-badge.svg"
            alt=""
          />
          <div class="sa-item__body">
            <p class="sa-item__title">{{ cert.name }}</p>
            <p class="sa-item__meta">{{ cert.description }}</p>
            <p class="sa-item__meta">
              <span>Duración: {{ cert.duration }} hs</span>
              <span>{{ cert.issuingAuthority }}</span>
            </p>
          </div>
          <app-icon-menu-button [menu]="menu" label="Más opciones"></app-icon-menu-button>
          <mat-menu #menu="matMenu">
            <button id="editButton" mat-menu-item (click)="dialogAction(cert)">
              Editar
            </button>
            <button id="deleteButton" mat-menu-item (click)="deleteCertification(cert.id)">
              Eliminar
            </button>
          </mat-menu>
        </li>
      } @empty {
        <li>
          <tp-empty-state
            icon="workspace_premium"
            title="Todavía no hay certificaciones"
            message="Agregá la primera certificación con el botón de arriba."
          ></tp-empty-state>
        </li>
      }
    </ul>
  </section>
</div>
